// extracted by mini-css-extract-plugin
export default {"subproductItem":"PaasCreateDetails-subproductItem_CceFd","allowMultiLine":"PaasCreateDetails-allowMultiLine_EpMg6"};